<template>
  <div class="activityList-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-select v-model="params.status" size="small" clearable placeholder="活动状态" @change="getWebActivity('status')">
        <el-option v-for="item in isOpen" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="searchActive('status')">搜索</el-button>
      <el-button type="primary" size="small" @click="activeAction('add')">+新增活动</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="id" label="活动ID" align="center" :show-overflow-tooltip="true" min-width="220" fixed></el-table-column>
      <el-table-column prop="title" label="活动名称" align="center" :show-overflow-tooltip="true" width="220"></el-table-column>
      <el-table-column prop="desc" label="活动描述" align="center" :show-overflow-tooltip="true" width="300">
        <template slot-scope="scope">{{ scope.row.desc || "未知" }}</template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="150">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="请在编辑中修改" placement="top-start">
            <el-switch v-model="scope.row.status" disabled></el-switch>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="活动开始时间" align="center" :show-overflow-tooltip="true" min-width="200">
        <template slot-scope="scope">{{ scope.row.startTime | changeDate }}</template>
      </el-table-column>
      <el-table-column prop="endTime" label="活动结束时间" align="center" :show-overflow-tooltip="true" min-width="200">
        <template slot-scope="scope">{{ scope.row.endTime | changeDate }}</template>
      </el-table-column>

      <el-table-column prop="operating" label="操作" align="center" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="activeAction('edit', scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5, 10, 15, 20]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" background @size-change="changeSize" :total="total" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑tag弹窗-->
    <active-action ref="activeAction" @handlerList="handlerActiveList"></active-action>
  </div>
</template>
<script>
import ActiveAction from "./components/activeAction";
import API from "@/api";
import { paramsFilter } from "@/utils/global";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      time: "",
      // 是否开启
      isOpen: [
        {
          label: "开启",
          value: true,
        },
        {
          label: "关闭",
          value: false,
        },
      ],
      params: {
        status: "",
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  components: {
    ActiveAction,
  },
  created() {
    this.getWebActivity();
  },
  methods: {
    // 请求活动列表
    getWebActivity(type) {
      if (type === "status") {
        this.formData.pageNumber = 1;
      }

      this.loading = true;
      let formData = paramsFilter(this.params);
      API.getWebActivity(formData)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 搜索列表
    searchActive() {
      this.getWebActivity();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.formparamsData.pageNumber = 1;
      this.getWebActivity();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getWebActivity();
    },
    // 编辑活动成功回掉
    handlerActiveList() {
      this.getWebActivity();
    },
    // 新增、删除tags
    activeAction(type, data) {
      this.$refs.activeAction.open(type, data);
    },
  },
};
</script>
<style scoped>
</style>
